import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import ErrorView from 'app/components/ErrorView'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  errorBox: {
    padding: '0 20%',
  },
}))

const NetworkError = (props) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const { onRetryFetching, title, isLoading = false, subtitle } = props

  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <CircularProgress color="secondary" />;
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'text-center flex justify-center items-center h-full',
        classes.errorBox,
      )}
    >
      <ErrorView
        action={onRetryFetching}
        title={
          title ||
          formatMessage(
            { id: 'error.network.unavailable.title' },
            { newline: <br /> },
          )
        }
        subtitle={
          subtitle ||
          formatMessage(
            { id: 'error.network.unavailable.body' },
            { newline: <br /> },
          )
        }
      />
    </div>
  )
}

NetworkError.propTypes = {
  isShow: PropTypes.bool,
  isLoading: PropTypes.bool,
  onRetryFetching: PropTypes.func,
  error: PropTypes.object,
}

export default NetworkError
